import { getImagePath, prop } from './utilities';

export function prepareOrderObject(order, shopId) {
  return {
    order_nr: order.order_nr,
    shopId,
    order_tprice: order.order_tprice,
    delivery_price: prop(order, 'delivery.delivery_price', 0),
    payment_price: prop(order, 'payment.payment_price', 0),
    delivery_addr_city: prop(order, 'delivery.delivery_addr_city'),
    delivery_addr_country:
      prop(order, 'delivery.delivery_addr_country') || 'SK',
  };
}

export function prepareOrderItemObject(item, orderNr) {
  const categoryPathString =
    prop(item, 'good_details_json.resolved_category_path') ||
    prop(item, 'product.publish.0.resolved_category_path') ||
    prop(item, 'resolved_category_path') ||
    '';

  return {
    order_nr: orderNr,
    product_id: item.product_id,
    product_name: item.product_name,
    categoryPathString,
    unitprice: item.unitprice,
    quantity: item.quantity,
  };
}

export function prepareCartItemObject(item, imageUrl, productUrl) {
  if (!item) {
    return;
  }

  const itemName =
    prop(item, 'product.publish.0.product_name') ||
    prop(item, 'product_detail.publish.0.product_name') ||
    prop(item, 'publish.0.product_name') ||
    prop(item, 'product.name') ||
    prop(item, 'product_name') ||
    prop(item, 'name');

  const imgUrl = getImagePath(imageUrl, prop(item, 'product.picture'), {
    width: 320,
    height: 320,
  });

  const itemUrl = `${productUrl}/${prop(item, 'product.publish.0.url') ||
    prop(item, 'product_detail.publish.0.url') ||
    prop(item, 'publish.0.url') ||
    prop(item, 'product.url') ||
    prop(item, 'url')}`;

  const itemDescription =
    prop(item, 'product.publish.0.description') ||
    prop(item, 'product_detail.publish.0.description') ||
    prop(item, 'publish.0.description') ||
    prop(item, 'product.description') ||
    prop(item, 'description');

  const itemPrice = prop(item, 'good.unitprice') || 0;

  return {
    productId: prop(item, 'product.product_id'),
    img_url: imgUrl,
    url: itemUrl,
    name: itemName,
    price: itemPrice,
    description: itemDescription,
  };
}
